import React from 'react';
import AccountPickerProvider from './AccountPickerProvider';
import AccountProvider from './AccountProvider';
import AccountTodayOverrideProvider from './AccountTodayOverrideProvider';
import CloudFunctionClientProvider from './CloudFunctionClientProvider';
import UsersProvider from './UsersProvider';
import ImpersonatorProvider from './ImpersonatorProvider';
import CurrentUserProvider from './CurrentUserProvider';
import CurrentUserContentSettingsProvider from './CurrentUserContentSettingsProvider';
import FeatureGatesProvider from './FeatureGatesProvider';
import RolesProvider from './RolesProvider';
import PortalsProvider from './PortalsProvider';
import AnalyticsProvider from './AnalyticsProvider';
import GqlClientProvider from './GqlClientProvider';
import BreadcrumbsProvider from './BreadcrumbsProvider';
import V3AppsProvider from './V3AppsProvider';
import UIVersionProvider from './UIVersionProvider';
import NavigateToAdminPortalForV2Staff from './NavigateToAdminPortalForV2Staff';
import GroupsProvider from './GroupsProvider';
import { FiscalPeriodsProvider } from './FiscalPeriodsProvider';
import MaintenanceModeGate from './MaintenanceModeGate';

const UserAndAccountProviders = ({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}) => (
  <AccountPickerProvider>
    <AccountProvider>
      <AccountTodayOverrideProvider>
        <CloudFunctionClientProvider>
          <UsersProvider>
            <ImpersonatorProvider>
              <CurrentUserProvider>
                <MaintenanceModeGate>
                  <FiscalPeriodsProvider>
                    <GroupsProvider>
                      <CurrentUserContentSettingsProvider>
                        <FeatureGatesProvider>
                          <RolesProvider>
                            <PortalsProvider>
                              <UIVersionProvider>
                                <V3AppsProvider>
                                  <NavigateToAdminPortalForV2Staff>
                                    <BreadcrumbsProvider>
                                      <AnalyticsProvider>
                                        <GqlClientProvider>
                                          {children}
                                        </GqlClientProvider>
                                      </AnalyticsProvider>
                                    </BreadcrumbsProvider>
                                  </NavigateToAdminPortalForV2Staff>
                                </V3AppsProvider>
                              </UIVersionProvider>
                            </PortalsProvider>
                          </RolesProvider>
                        </FeatureGatesProvider>
                      </CurrentUserContentSettingsProvider>
                    </GroupsProvider>
                  </FiscalPeriodsProvider>
                </MaintenanceModeGate>
              </CurrentUserProvider>
            </ImpersonatorProvider>
          </UsersProvider>
        </CloudFunctionClientProvider>
      </AccountTodayOverrideProvider>
    </AccountProvider>
  </AccountPickerProvider>
);

export default UserAndAccountProviders;
